<template>
    <account :params="params.form">
        <template #before>
            <a-select
                class="account__select-nav"
                label=""
                name="categories"
                :options="params.menu"
                display="title"
                value="url"
                hideSelected
                v-model="currentPage"
                dropdownClasses="account__select-nav-dropdown"
            >
                <template #item="item">
                    <div class="flex v-center account__select-nav-item">1
                        <a :href="item.url">{{ item.title }}</a>
                    </div>
                </template>
            </a-select>
        </template>
        <a-tab v-for="(tab, i) in params.form.tabs" :key="i" v-model="curentTabIndex" :name="i" :show="i==defShowIndex">
          <div>
              <ProjectListSection
                  @compliteTask="compliteTask"
                  :list-data="tab.projects"
                  :messages="params.messages"
                  :compliteBtn="tab.compliteBtn"
                  :emptyBlock="params.emptyBlock">
                  <template #title>
                      <div class="flex v-center">
                        <h3 class="nomargin">{{tab.subTitle.text}}</h3>
                        <ABadge class="ml-3">{{tab.subTitle.number}}</ABadge>
                      </div>
                  </template>
                  <template #after>
                    <ABtn label="Показать еще =)" v-if="tab.pageMore" class="transparent gray w-100"/>
                  </template>
              </ProjectListSection>
          </div>
          <div v-if="tab.text" v-html="tab.text"></div>
        </a-tab>
        <template #aside>
            <account-card v-bind="params.cardInfo" v-if="params.cardInfo">
                <template #actions>
                  <div class="ActionCard__button" v-if="isCompany">
                    <ABtn :label="params.newTask.text"
                        color="#fff"
                        bg="var(--c-secondary-200)"
                        :href="params.newTask.link"
                    />
                  </div>
                </template>
            </account-card>

            <aside-nav :items="params.menu"/>
            <ProgressCard v-if="params.progress" :data="params.progress"/>
            <UserDescription
                v-if="params.user"
                :description="params.user.description"
                :social="params.user.social"
            />
            <IntroCard/>
        </template>
    </account>

    <RespondComplete v-if="params.popupComplete" :result="popupComplete" :taskId="curentCompliteTaskId" :respId="curentCompliteResponseId"/>
</template>

<script>

import {ref, computed} from 'vue'
import Account from './Account.vue'
import AccountCard from '../cards/AccountCard.vue'
import AsideNav from '../AsideNav.vue'
import {
    ATab,
    ABtn,
    ABadge,
    AField,
    AInput,
    ACheckbox,
    ASelect,
    AChip,
    ADatePicker,
    useAProgressBar,

    AVideo,
} from '../ui'
import UserFiles from '../cards/UserFiles.vue'
import {required, isEmail, isPhone, fileRules} from '../../libs/Validators'
import {getType} from '../ui/utils/helpers'
import {saveAccountNPO, send} from '../../services/api'
import {Swiper, SwiperSlide} from 'swiper/vue';
import {Navigation} from "swiper";

import 'swiper/css';
import 'swiper/css/navigation';
import ProgressCard from "../cards/ProgressCard";
import UserDescription from "../cards/UserDescription";
import TagListSection from "./TagListSection";
import IntroCard from "../cards/IntroCard";
import ProjectListSection from "./ProjectListSection";
import ActionCard from "../cards/ActionCard";

export default {
    name: 'AccountProjects',
    components: {
        ActionCard,
        ProjectListSection,
        IntroCard,
        TagListSection,
        UserDescription,
        ProgressCard,
        Account,
        AccountCard,
        AsideNav,
        ATab,
        ABtn,
        ABadge,
        UserFiles,
        AField,
        AInput,
        ACheckbox,
        ASelect,
        AChip,
        ADatePicker,
        required,
        isEmail,
        isPhone,
        fileRules,
        Swiper,
        SwiperSlide,
        Navigation,
        AVideo
    },
    props: ['params'],
    setup: (props, ctx) => {
      const curentCompliteTaskId = ref(null);
      const curentCompliteResponseId = ref(null);

      const popupComplete = ref(props.params.popupComplete);
      const defShowIndex = ref(0);
      if(props.params.form.tabs[defShowIndex.value]?.disabled) {
        for(let index in props.params.form.tabs) {
          if(props.params.form.tabs[defShowIndex.value]?.disabled) {
            defShowIndex.value = index;
          }
        }
      }
      const curentTabIndex = ref(defShowIndex.value);

      const compliteTask = (id) =>  {

        for(let index in props.params.popupComplete.fields) {
            let title = props.params.popupComplete.fields[index].title;
            if(title!=undefined) {
                title = title.replace('#NKO#', props.params.nkoNamesByProjectId[id]);
                popupComplete.value.fields[index].title = title;
            }
        }
        let curProj = props.params.form.tabs[curentTabIndex.value].projects.find(project=>project.id==id);
        if(curProj) {
          curentCompliteResponseId.value = curProj.response;
        }
        curentCompliteTaskId.value = id;
      };
        const btnNext = ref(null)
        const btnPrev = ref(null)
        const currentPage = ref(props.params.menu.filter(row => row.current)[0])

        const isCompany = computed(() => {
            return props.params.isCompany === true
        })

        const isVolunteer = computed(() => {
            return props.params.isVolunteer === true
        })

        const addRequest = () => {
            console.log('addRequest')
        }



        return {
          required,
          compliteTask,
          curentCompliteTaskId,
          curentCompliteResponseId,
            curentTabIndex,
            popupComplete,
            isEmail,
            isPhone,
            fileRules,
            defShowIndex,
            btnNext,
            btnPrev,
            modules: [Navigation],
            currentPage,
            isCompany,
            isVolunteer,
            addRequest
        }
    },
}
</script>

<style lang="scss" scoped>
.account__body-section {
    margin-top: 72px;

    .col:first-child {
        .account__body-section {
            margin-top: 0px;
        }
    }
}

::v-deep(.account-card) {
    .a-avatar__inner {
        width: auto !important;
        height: 130px !important;
        border-radius: 0;

        @include tablet {
            max-height: 80px;
        }
    }

    .account-card__bottom {
        @include tablet {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        @include mobile {
            display: block;
        }
    }
}

::v-deep(.account__body-section) {
    h3 {
        margin-bottom: 0;
    }
}

::v-deep(.account__header) {
    display: none !important;
}

.user-files {
    margin-top: 28px;
}

.user-files__remove-btn {
    font-size: 16px;
    color: var(--c-gray-500);
    cursor: pointer;
    transition: all .3s ease;

    &:hover {
        color: var(--c-gray-400);
    }
}

.account__select-nav {
    display: none;
    @include tablet {
        display: flex;
    }
}

.aside-nav {
    @include tablet {
        display: none;
    }
}


</style>

<style lang="scss">
.page__account {
    .tags {
        .a-chip__inner {
            background: #fff;
        }
    }
}

.account__additional-link .label {
    margin-left: 62px;
    @include mobile {
        margin-left: 44px;
    }
}

.account__select-nav-dropdown .a-item {
    padding: 0;

    a {
        color: var(--c-gray-100);
        width: 100%;
        display: flex;
        align-items: center;
        padding: 12px 16px;

        &:hover {
            text-decoration: none;
        }
    }
}
</style>